import { useSelector } from "react-redux";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { selectCurrentSong, selectCurrentVerse, selectCurrentVerseIndex, selectHasSong, selectIsHost } from "../../selectors";
import { isTabActive, tabsFor } from "../../lib/navigation";
import { verseLabel } from "../../lib/lyrics";

/** The live bar: what is on screens right now, one tap from anywhere back to the live page. */
const LiveBar = () => {
  const navigate = useNavigate();
  const isHost = useSelector(selectIsHost);
  const code = useSelector((state) => state.session.Code);
  const song = useSelector(selectCurrentSong);
  const verse = useSelector(selectCurrentVerse);
  const index = useSelector(selectCurrentVerseIndex);
  const hasSong = useSelector(selectHasSong);
  const title = hasSong ? `${song.Title} · ${verseLabel(verse, index)}` : "Nothing on screens yet";

  return (
    <button type="button" className={`livebar${isHost ? " livebar-host" : ""}`} onClick={() => navigate("/lyrics")}>
      <span className="dot dot-lg" aria-hidden="true" />
      <span className="grow">
        <span className="livebar-kicker">{isHost ? `You are hosting · ${code}` : "Following the host"}</span>
        <span className="livebar-title">{title}</span>
      </span>
      <span className="arrow" aria-hidden="true">
        ↗
      </span>
    </button>
  );
};

/** Songs, Favorites, Sets and Live (hosts) or Join (guests), fixed at the bottom of the screen. */
const BottomNav = ({ liveBar = false }) => {
  const { pathname } = useLocation();
  const isHost = useSelector(selectIsHost);

  return (
    <nav className="nav" aria-label="Main">
      {liveBar && <LiveBar />}
      <div className="nav-tabs">
        {tabsFor(isHost).map((tab) => (
          <NavLink key={tab.to} to={tab.to} className={`nav-tab${isTabActive(tab, pathname) ? " active" : ""}`} aria-current={isTabActive(tab, pathname) ? "page" : undefined}>
            <span className="glyph" aria-hidden="true">
              {tab.glyph}
            </span>
            <span className="label">{tab.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default BottomNav;
